<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <div class="d-sm-flex d-none user-nav">
        <span class="user-status text-sm mr-1">Current Financial Date: </span>
        <p class="user-name font-weight-bolder mb-0 text-capitalize">
          {{ currentFinancialDate ? toDateWithYear(currentFinancialDate.financialDate) : '' }}
          <span class="user-status ml-2">{{ userData ? userData.branch : '' }}</span>
        </p>
        <span
          v-if="tillAccountBalance.accountName !== null"
          class="user-status text-sm mr-1 ml-2"
        >{{ tillAccountBalance.accountName }} - <span
          v-if="tillAccountBalance.accountNumber !== null"
          class="user-name font-weight-bolder mb-0 text-capitalize"
        >{{ tillAccountBalance.accountNumber }}</span></span>
        <span
          v-if="tillAccountBalance.ledgerBalance !== null"
          class="user-status text-sm mr-1"
        >Balance:<span class="user-name font-weight-bolder mb-0 ml-1 text-capitalize">{{ tillAccountBalance.ledgerBalance ? toBalance(tillAccountBalance.ledgerBalance) : '' }}</span></span>
      </div>

      <!-- Bookmarks Container -->
      <!-- <bookmarks /> -->
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <locale />
      <dark-Toggler class="d-none d-lg-block" />
      <!-- <search-bar />
      <cart-dropdown /> -->
      <!-- <notification-dropdown /> -->
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import { toDateWithYear } from '@/helpers/formatDate'
import Locale from './components/Locale.vue'
import DarkToggler from './components/DarkToggler.vue'
// import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import {
  toBalance,
} from '@/helpers/formatAmount'

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    // SearchBar,
    Locale,
    DarkToggler,
    // NotificationDropdown,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      toDateWithYear,
      toBalance,
    }
  },
  computed: {
    ...mapGetters({
      currentFinancialDate: 'operations/getCurrentFinancialDate',
      userData: 'auth/getCurrentUser',
      tillAccountBalance: 'account/getTillAccountBalance',
    }),
  },
  mounted() {
    this.fetchTillAccountBalance()
  },
  methods: {
    ...mapActions({
      getTillAccountBalance: 'account/getTillAccountBalance',
    }),
    async fetchTillAccountBalance() {
      await this.getTillAccountBalance({ userId: this.userData.id })
    },
  },
}
</script>
